import { css } from "styled-components";
import { theme } from "./theme";

type BreakpointKey = keyof typeof theme.breakpoints;

type Media = Record<BreakpointKey, (...args: Parameters<typeof css>) => ReturnType<typeof css>>;

export const media: Media = (Object.keys(theme.breakpoints) as BreakpointKey[]).reduce((acc, bp) => {
  acc[bp] = (...args: Parameters<typeof css>) => css`
    @media (max-width: ${theme.breakpoints[bp]}) {
      ${css(...args)}
    }
  `;
  return acc;
}, {} as Media);
